<div *ngIf="loading">
    <div class="adn-loading-container">
        <div class="adn-loading-wrapper">
            <div class="adn-loading-spinner"></div>
            <div>Loading...</div>
        </div>
    </div>
</div>